module.exports = __webpack_public_path__ + "static/hola-4d49167ff2f768d71ac982e10b99a483.jpg";